// src/api/consulting/partnerConsulting.js
import axios from "axios";
import { WP_BASE } from "../lib/http";

function normalizeLang(lang) {
  const s = String(lang || "").toUpperCase().trim();
  return s === "EN" || s === "JP" || s === "ZH" ? s : "ZH";
}

function trim(v) {
  return String(v ?? "").trim();
}

/**
 * IMPORTANT:
 * - This endpoint is under /wp-json/api (NOT /wp-json/seho/v1)
 * - Use WP_BASE from src/lib/http.js so LAN works and no :3000 is used.
 *
 * Final URL:
 *   {WP_BASE}/wp-json/api/consulting/partner
 *
 * Example WP_BASE:
 *   http://192.168.0.102/wp-headless
 */
function apiBase() {
  return `${String(WP_BASE || "").replace(/\/+$/, "")}/wp-json/api`;
}

const api = axios.create({
  baseURL: apiBase(),
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

function unwrapWpError(err, fallbackMsg = "Request error") {
  const status = err?.response?.status;
  const data = err?.response?.data;

  // WP_Error often looks like:
  // { code, message, data: { status, field? } }
  const msg =
    (data && (data.message || data?.data?.message)) ||
    err?.message ||
    fallbackMsg;

  const e = new Error(msg);
  e.httpStatus = status || data?.data?.status || null;
  e.payload = data || null;
  e.field = data?.data?.field || null;
  return e;
}

/**
 * Partner Consulting REST API
 * POST /wp-json/api/consulting/partner
 */
export const PartnerConsultingAPI = {
  async create(input, { lang = "ZH", mode = "b2b" } = {}) {
    const payload = {
      lang: normalizeLang(lang),
      mode: String(mode || "b2b"),

      lastName: trim(input?.lastName),
      firstName: trim(input?.firstName),

      company: trim(input?.company),
      department: trim(input?.department),
      title: trim(input?.title),

      email: trim(input?.email),
      emailConfirm: trim(input?.emailConfirm),

      phoneCountry: trim(input?.phoneCountry),
      phone: trim(input?.phone),

      faxCountry: trim(input?.faxCountry),
      fax: trim(input?.fax),

      zip: trim(input?.zip),
      prefecture: trim(input?.prefecture),
      cityArea: trim(input?.cityArea),
      cityAddr: trim(input?.cityAddr),
      building: trim(input?.building),

      subject: trim(input?.subject),
      detail: trim(input?.detail),

      agree: !!input?.agree,
    };

    try {
      const res = await api.post(`/consulting/partner`, payload, {
        headers: {
          "X-Lang": normalizeLang(lang),
        },
      });
      // expected now (after your backend update):
      // { ok: true, id: number, consultingID?: string, emailWarnings?: string[] }
      return res.data;
    } catch (err) {
      throw unwrapWpError(err, "Submission failed. Please try again later.");
    }
  },
};

export default PartnerConsultingAPI;
